import { z } from "zod";
import { Country, PaymentMethod } from "./types";

// export const paymentMethodSchema = z.enum(["bankAccount", "wallet"], {
//   errorMap: () => ({
//     message: "choosePaymentMethod",
//   }),
// });

export const paymentMethodSchema = z.enum(["wallet"], {
  errorMap: () => ({
    message: "choosePaymentMethod",
  }),
});

export const paymentMethodStepSchema = z.object({
  paymentMethod: paymentMethodSchema,
});

export const countrySchema = z.enum(["egypt", "other"], {
  errorMap: () => ({
    message: "chooseCountry",
  }),
});

const countryStepSchema = z.object({
  country: countrySchema,
});

export const egyptianWalletTypeSchema = z.enum(["vodafone", "orange", "etisalat", "we"], {
  required_error: "Wallet type is required",
});

const walledDetailsEgyptStepSchema = z.object({
  walletType: egyptianWalletTypeSchema,
  phoneNumber: z
    .string({
      required_error: "Phone number is required",
    })
    .min(10, "Phone number must be at least 10 digits"),
  email: z
    .string({
      required_error: "Email is required",
    })
    .email("Invalid email address"),
});

export const paypalAccountTypeEnum = z.enum(["personal", "business"], {
  invalid_type_error: "Account type is required",
  required_error: "Account type is required",
});

export const paypalAccountTypeSchema = z.preprocess(
  (val) => (val === "" || val === undefined || val === null ? undefined : val),
  paypalAccountTypeEnum
);

const walledDetailsOtherStepSchema = z
  .object({
    accountType: paypalAccountTypeSchema,
    phoneNumber: z
      .string({
        required_error: "Phone number is required",
      })
      .min(10, "Phone number must be at least 10 digits"),
    email: z
      .string({
        required_error: "Email is required",
      })
      .email("Invalid email address"),
    reEnterEmail: z
      .string({
        required_error: "Please re-enter your email",
      })
      .email("Invalid email address"),
    currency: z
      .string({
        required_error: "Currency is required",
      })
      .min(1, "Currency is required"),
  })
  .refine((data) => data.email === data.reEnterEmail, {
    message: "Emails do not match",
    path: ["reEnterEmail"],
  });

const bankAccountDetailsStepSchema = z.object({
  accountHolderName: z
    .string({
      required_error: "Account holder name is required",
    })
    .min(1, "Account holder name is required"),
  bankName: z
    .string({
      required_error: "Bank name is required",
    })
    .min(1, "Bank name is required"),
  ibanNumber: z
    .string({
      required_error: "IBAN number is required",
    })
    .min(1, "IBAN number is required"),
  bankCodeSwift: z
    .string({
      required_error: "SWIFT code is required",
    })
    .min(1, "SWIFT code is required"),
  country: z
    .number({
      required_error: "Country is required",
    })
    .min(1, "Country is required"),
  email: z
    .string({
      required_error: "Email is required",
    })
    .email("Invalid email address"),
});

export const getSchemaByStep = ({
  step,
  country,
  paymentMethod,
}: {
  step: number;
  country?: Country;
  paymentMethod?: PaymentMethod;
}) => {
  if (step === 0) return paymentMethodStepSchema;

  if (step === 1 && paymentMethod === "wallet") return countryStepSchema;
  // if (step === 1 && paymentMethod === "bankAccount") return bankAccountDetailsStepSchema;

  if (step === 2 && paymentMethod === "wallet" && country === "egypt") return walledDetailsEgyptStepSchema;
  if (step === 2 && paymentMethod === "wallet" && country === "other") return walledDetailsOtherStepSchema;

  return z.object({}); // fallback empty schema
};
